import type { Message } from '../../types';

export const conversationService = () => {
  // ================================
  // Composables
  // ================================
  const { sendMessageToAssistant } = openAIRepository();

  // ================================
  // Data
  // ================================
  const messages = ref<Message[]>([]);
  const thinking = ref(false);

  // ================================
  // Methods
  // ================================

  const sendMessage = async (message: string) => {
    // Add user message to messages
    messages.value.push({
      role: 'user',
      content: {
        type: 'message',
        data: {
          text: message,
        },
      },
    });

    // Send message to assistant
    thinking.value = true;
    const assistantMessage = await sendMessageToAssistant(message);
    messages.value.push({
      role: 'assistant',
      content: assistantMessage,
    });
    thinking.value = false;
  };

  return {
    messages,
    sendMessage,
    thinking,
  };
};
